(function () {
    'use strict';

    var publicServices = {
        getStyleShots: getStyleShots
    };


    function getStyleShots(model) {
        var currentFeatures = model.get('currentFeatures');
        var styleshots = model.get('styleshots');
        var cylindoContent = model.get('cylindoContent');
        var ss = (currentFeatures && currentFeatures.styleshots instanceof Array) && styleshots && cylindoContent ?
            currentFeatures.styleshots : [];
        return ss;
    }

    window.cylindo.addModule('cylindo.helpers.styleshots', publicServices);
}).call(this);
